import { SxProps } from '@mui/material';
import { Theme } from '@mui/system';

export const catalogEntryListCompareCollectorCloseIconSX: SxProps<Theme> = () => ({
	position: 'absolute',
	right: '5px',
	top: '5px',
	p: 0,
	width: '18px',
	height: '18px',
	color: 'text.secondary',
	cursor: 'pointer',
	backgroundColor: 'transparent',
	'&:hover': {
		backgroundColor: 'transparent',
		color: 'primary.main',
	},
});
